export default __webpack_public_path__ + "static/parimal_gosai_avatar-575cfe8f15663c23b4a116e6e63156f1.png";